import {
    BillingDetailsActions,
    UPSERT, CLEAR
} from './billing-details.actions';

import { Address } from '../../../model/address.model';

export interface State {
    billingDetails: Address;
}

const initialState = {
    billingDetails: null
};

export function reducer(state = initialState, action: BillingDetailsActions) {
    switch (action.type) {
    case UPSERT:
        return {
            ...state,
            billingDetails: { ...state.billingDetails, ...action.payload },
        };
    case CLEAR:
        return {
            ...state,
            billingDetails: null,
        };
    default:
        return state;
    }
}

export const getBillingDetails = (state: State) => state.billingDetails;

